// extracted by mini-css-extract-plugin
export default {"button":"Button_button__A5gFc","matrix":"Button_matrix__Car5E","transparent":"Button_transparent__pX6vN"};